import React, { useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LogIn } from "lucide-react";

export default function SignIn() {
  const { user, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const error = params.get("error");

  useEffect(() => {
    if (!loading && user) navigate("/network", { replace: true });
  }, [loading, user, navigate]);

  const startGoogleAuth = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center bg-[#FFF8E7] px-4" data-testid="page-signin">
      <div className="w-full max-w-xl bg-white border-2 border-[#0A0A0A] p-10 md:p-14">
        <div className="text-sm uppercase tracking-[0.2em] font-bold text-[#1A5DFF] mb-4">Members area</div>
        <h1 className="font-heading font-black text-[#0A0A0A] text-3xl sm:text-4xl tracking-tight leading-tight">
          Sign in to access the Network directory.
        </h1>
        <p className="mt-6 text-[#2C2C2C] leading-relaxed">
          Sign in with Google to view our vetted directory of neurodivergent film professionals.
          Your name and email are used only to confirm membership — we never share them.
        </p>

        {error && (
          <div className="mt-6 border-2 border-[#FF2E63] bg-[#FFF8E7] text-[#0A0A0A] p-4" role="alert" data-testid="signin-error">
            We couldn&apos;t complete sign-in. Please try again, or email <a className="underline" href="mailto:create@divergentcinema.co.uk">create@divergentcinema.co.uk</a> if it keeps happening.
          </div>
        )}

        <button
          onClick={startGoogleAuth}
          data-testid="google-signin-btn"
          className="mt-8 w-full bg-[#FF2E63] text-[#FFF8E7] hover:bg-[#E0204F] rounded-none px-6 py-4 text-base font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#FF2E63] inline-flex items-center justify-center gap-3"
        >
          <LogIn className="w-5 h-5" /> Continue with Google
        </button>

        <div className="mt-8 text-sm text-[#2C2C2C] border-t border-[#0A0A0A] pt-6">
          Not a member yet?{" "}
          <Link
            to="/membership"
            className="text-[#0A0A0A] underline underline-offset-4 hover:text-[#FF2E63]"
            data-testid="signin-membership-link"
          >
            Become a member →
          </Link>
        </div>
      </div>
    </div>
  );
}
